export const refreshLaunchDarklyContext = async ( email, oktaUsername, state, ldClient ) => {
    const actualWebId = oktaUsername.substring( 0, oktaUsername.indexOf( '@' ) )

    const newContext= {
        anonymous: false,
        kind: 'user',
        key: 'MSLoginUI',
        name: actualWebId,
        email: email,
        WebID: actualWebId,
        State: state
    }

    await ldClient.identify( newContext, null ) 
}

export const refreshLDContextAndGetFFValue = async ( email, oktaUsername, state, ldClient, ffName ) => {
    if( !ldClient || !ffName || !oktaUsername ) return false

    await refreshLaunchDarklyContext( email, oktaUsername, state, ldClient )

    return ldClient.allFlags()[ ffName ] 
}